export default __webpack_public_path__ + "static/24-ace6bc727023294f3f2e71e1f56d0ed2.png";